var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStopped(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 104,
    viewBox: "0 0 114 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_9293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.80127 25.7225V74.9383C0.80127 75.948 1.34111 76.8878 2.22086 77.3876L43.419 101.181C44.2987 101.691 45.3784 101.691 46.2482 101.181L87.4463 77.3876C88.326 76.8778 88.8659 75.948 88.8659 74.9383V25.7225L44.8286 51.1452L0.80127 25.7225Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.80127 25.7226L44.8386 0.299927L88.8759 25.7226L44.8386 51.1553L0.80127 25.7226Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8064 35.5497L61.8337 10.1271L71.7508 15.8554L27.7135 41.2881L27.6935 60.3226L17.7964 54.6142L17.8064 35.5497Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8384 51.1553V101.321",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4806 82.6462V91.0538L23.335 82.1463V73.7388L38.4806 82.6462Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.756 104C102.421 104 113.499 92.9223 113.499 79.2571C113.499 65.592 102.421 54.5143 88.756 54.5143C75.0909 54.5143 64.0132 65.592 64.0132 79.2571C64.0132 92.9223 75.0909 104 88.756 104Z",
    fill: "#0C57BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5643 77.8675V70.2397C94.5643 69.14 93.6746 68.2502 92.5749 68.2502C91.4752 68.2502 90.5854 69.14 90.5854 70.2397",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5956 76.8778V68.2603C90.5956 67.1606 89.7058 66.2709 88.6061 66.2709C87.5064 66.2709 86.6167 67.1606 86.6167 68.2603V70.2497",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5644 72.2291C94.5644 71.1294 95.4541 70.2397 96.5538 70.2397C97.6535 70.2397 98.5433 71.1294 98.5433 72.2291V84.3056C98.5433 88.6944 94.9843 92.2433 90.6055 92.2433H88.6161C85.8369 92.2433 84.1474 91.3936 82.6678 89.924L77.8292 85.0854C77.0495 84.2256 77.1194 82.896 77.9792 82.1162C78.779 81.3965 79.9986 81.3965 80.7984 82.1162L82.6678 83.9857V70.2397C82.6678 69.14 83.5476 68.2502 84.6473 68.2502C85.7469 68.2502 86.6367 69.14 86.6367 70.2397V77.3676",
    stroke: "white",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_9293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112.997,
    height: 104,
    fill: "white",
    transform: "translate(0.501465)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopped);
export default __webpack_public_path__ + "static/media/stopped.7a128c723c87abd4624ce90a39424755.svg";
export { ForwardRef as ReactComponent };